import React, { Component } from 'react'

export default class PinterestSocial extends Component {

  componentDidMount() {
    if (!window.doBuild) {
      this.preloadWidgetScript()
    } else {
      window.doBuild()
    }
  }
  
  preloadWidgetScript = () => {
    const script = document.createElement('script')
    script.async = true
    script.dataset.pinBuild = 'doBuild'
    script.src = '//assets.pinterest.com/js/pinit.js'
    document.body.appendChild(script)
  }

  render() {
    return(
      <div hidden={this.props.hidden}>
        <a  data-pin-do           ="embedUser" 
            data-pin-board-width  ={this.props.width}
            data-pin-scale-height ={this.props.height}
            data-pin-scale-width  ={this.props.widthScale}
            href                  ={this.props.url}></a>
      </div>
    )
  }
}

PinterestSocial.defaultProps = {
  hidden:     true,
  width:      '300',
  height:     '500',
  widthScale: '100',
  url:        'https://www.pinterest.com/showcaseidx/'
}


// WEBPACK FOOTER //
// client/components/social/PinterestSocial.js